import React from 'react'
import { createPortal } from 'react-dom'

export function SideName() {
  return createPortal(
    <div className='side-name'>
        <p className='m-0'>
          <a href="https://www.github.com/osas2211" target={"_blank"} rel="noreferrer" className='d-inline-block'><i class="fab fa-github"></i></a>
          <a href="https://www.linkedin.com/in/osaretin-osariemen-03047a1a6/" target={"_blank"} rel="noreferrer" className='d-inline-block'><i class="fab fa-linkedin"></i></a>
          <a href="https://www.instagram.com/franklophon" target={"_blank"} rel="noreferrer" className='d-inline-block'><i class="fab fa-instagram"></i></a>
          <a href="https://twitter.com/Osaretinfrank3" target={"_blank"} rel="noreferrer" className='d-inline-block'><i class="fab fa-twitter-square"></i></a>
        </p>
        <div></div>
    </div>, document.body
  )
}
